<template>
  <div class="information">
    <div class="articles">
      <Article
        v-for="article in articles"
        v-bind:key="article.id"
        v-bind:title="article.title"
        v-bind:text="article.text"
        v-bind:status="article.status"
      />
    </div>
  </div>
</template>

<script>
import rest from "../rest";
import Article from "../components/Article";

export default {
  components : { Article},
  data() {
    return {
      articles: null
    };
  },
  mounted() {
    rest.publicArticles().then(response => {
      if (response.status === 200) this.articles = response.data.data;
    });
  }
}
</script>

<style scoped>
.articles > article {
  text-decoration: underline;
}
</style>